import React, { useEffect } from 'react';

// Vite env lookup helper with process.env fallback
const env = (k) => (import.meta?.env?.[`VITE_${k}`] ?? process.env?.[`REACT_APP_${k}`]);

// Tawk.to Configuration - try both spellings for compatibility
const TAWK_TO_PROPERTY_ID = env('TAWK_TO_PROPERTY_ID') || env('TAWKTO_PROPERTY_ID');
const TAWK_TO_WIDGET_ID = env('TAWK_TO_WIDGET_ID') || env('TAWKTO_WIDGET_ID');

export default function TawkToChat() {
  useEffect(() => {
    // Skip script injection if IDs are not configured
    if (!TAWK_TO_PROPERTY_ID || !TAWK_TO_WIDGET_ID) {
      console.warn('[Tawk.to] Property/Widget ID not configured — widget disabled.');
      return;
    }

    // Load Tawk.to script
    const loadTawkTo = () => {
      if (typeof window !== 'undefined' && !window.Tawk_API) {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://embed.tawk.to/${TAWK_TO_PROPERTY_ID}/${TAWK_TO_WIDGET_ID}`;
        script.charset = 'UTF-8';
        script.setAttribute('crossorigin', '*');

        script.onload = () => {
          console.log('[Tawk.to] Chat widget loaded successfully');
          // Adjust Tawk.to widget position to avoid collisions
          if (window.Tawk_API) {
            window.Tawk_API.onLoad = function() {
              // Tawk.to widget z-index is controlled by their system
              // We'll ensure it doesn't conflict with our chat drawer (z-index: 2000)
              // and WhatsApp FAB (z-index: 1500)
            };
          }
        };

        script.onerror = () => {
          console.error('[Tawk.to] Failed to load chat widget');
        };

        document.body.appendChild(script);
      }
    };

    loadTawkTo();

    // Cleanup
    return () => {
      // Tawk.to doesn't provide a clean unload method
      // The script remains loaded for the session
    };
  }, []);

  return null; // This component doesn't render anything visible
}
